module.exports = __webpack_public_path__ + "CreativeDirection35.jpg?338ef4944c1bccb506b75875927db984";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection35.jpg
// module id = 48
// module chunks = 0